<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import { sendNotification } from "@/utils/helpers/notification";
import Pagination from "@/components/standard/OcupationalMedicine/dangerPagination";
import Swal from "sweetalert2";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import restriccionesColaboracionesAPI from "../../../services/standards/restriccionesColaboraciones/restriccionesColaboracionesAPI";
import { dateFormat } from "@/utils/helpers/format";
import SeguimientosPagination from "../../../components/standard/RestriccionesColaboraciones/SeguimientosPagination.vue";
import RestriccionesSeguimientosPagination from "../../../components/standard/RestriccionesSeguimientos/RestriccionesSeguimientosPagination.vue";
import inspeccionesSeguridadAPI from "../../../services/standards/inspeccionesSeguridad/inspeccionesSeguridadAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "4.2.4 Inspecciones de seguridad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Pagination,
    CheckModal,
    SeguimientosPagination,
    RestriccionesSeguimientosPagination,
  },
  data() {
    return {
      title: "4.2.4 Inspecciones de seguridad",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Inspecciones de seguridad",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/inspecciones-seguridad`,
        },
        {
          text: "Evidencia inspección",
          active: true,
        },
      ],

      itemData: null,
      userSelected: null,
      Datalist: [],
      inspeccion: [],
      selectec: null,
      usersList: [],
      employee: null,
      file: null,
      empleado: null,
      dataI: null,
      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      ocupationalMedicine: {
        id: null,
        employee_id: null,
      },
      evidencia: {
        file: null,
        safety_inspections_id: this.$route.params.id,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      lista: null,
      listaSeguimientos: [],
      employeeID: null,
      item: null,
      itemData: null,
      form_submitting: false,
      listaII: null,
      restriccionesColaboraciones: {
        labor_status: "En curso",
        recommendations: null,
        evidence: null,
        occupational_medical_danger_id: this.$route.params.id,
      },
      full_name: null,
      submitted: false,
      lastId: 1,
      deleteCount: 0,
    };
  },

  validations: {
    file: {
      required,
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(28)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.4/${this.$route.params.id}/evidencia/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.4/${this.$route.params.id}/evidencia/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evidencia.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getshow() {
      inspeccionesSeguridadAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.inspeccion = response.data;
          this.employeeID = response.data.employeeID;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getSeguimientos() {
      restriccionesColaboracionesAPI
        .get(this.$route.params.id)
        .then((response) => {
          this.listaSeguimientos = response.danger.labor_restrictions;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getDanger() {
      restriccionesColaboracionesAPI
        .get(this.$route.params.id)
        .then((response) => {
          this.employee = response.employee.full_name;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false
        return;
      } else {
        let response = await this.uploadDocument();
        if (response) {
          const data = {
            file: this.evidencia.file,
            safety_inspections_id: this.evidencia.safety_inspections_id,
            employee_id: this.inspeccion.employee_id,
            companies_id: this.evidencia.companies_id,
          };
          inspeccionesSeguridadAPI
            .saveEvidence(data)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 48,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.sendNotification(65, 48, true);
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 2000);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido registrar, error carga documentos!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    getUsersByID() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      inspeccionesSeguridadAPI
        .getEvidence(this.companyID, this.$route.params.id)
        .then((response) => {
          let seguimientos = response.data.data;
          this.lista = seguimientos;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteSeguimiento(id) {
      inspeccionesSeguridadAPI.deleteE(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 48,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha sido eliminado con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getUsersByID();
    this.getList();
    this.getItemData();
    this.getSeguimientos();
    this.getDanger();
    this.getshow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe realizar realizar las visitas de
                      inspección sistemática a las instalaciones, maquinaria o
                      equipos, incluidos los relacionados con la prevención y
                      atención de emergencias; con la participación del COPASST.
                    </p>
                    <p>
                      En este ítem el responsable de la implementación, debe
                      elaborar la programación de las diferentes inspecciones a
                      realizar, definiendo la frecuencias de éstas y
                      posteriormente debe subir las evidencias que soportes las
                      inspecciones realizadas.
                    </p>
                    <p>
                      En caso de evidenciar alguna condición insegura que
                      requiera intervención, deberá elaborar el plan de acción
                      en el ítem 7.1.1
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>
              <hr />

              <div class="row mt-2">
                <h4 class="header-title col-4">Responsable:</h4>
                <h4 class="header-title col-8">
                  {{ this.inspeccion.full_name }}
                </h4>
              </div>

              <div class="row mt-2">
                <h4 class="header-title col-4">Inspección a realizar</h4>
                <h4 class="header-title col-8">
                  {{
                    this.inspeccion.name === "Otro"
                      ? this.inspeccion.other
                      : this.inspeccion.name
                  }}
                </h4>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form class="form-inline">
                            <div class="form-group mr-2">
                              <label for="productssearch-input" class="sr-only">Buscar</label>
                              <input type="search" class="form-control border-light" id="productssearch-input"
                                placeholder="Buscar..." />
                            </div>
                            <button :disabled="!allowAccess()" type="button" class="btn btn-primary mb-2 mb-sm-0">
                              <i class="mdi mdi-search-web"></i>
                            </button>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th>Fecha</th>
                              <th class="text-center align-middle">
                                Responsable
                              </th>
                              <th class="text-center align-middle">
                                Evidencia inspección
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td>
                                {{ dateConvert(dato.created_at) }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.full_name }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <div>
                                    <b-dropdown :disabled="!allowAccess()" variant="primary">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>

                                      <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                        " :to="{
                                          path: `/forms/estandares/evidencia-inspeccion-editar/${dato.id}`,
                                        }">
                                        Editar</b-dropdown-item>
                                      <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                        " v-on:click="deleteSeguimiento(dato.id)">Eliminar</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--    <RestriccionesSeguimientosPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" /> -->
                        <div>
                          <!--      <SeguimientosPagination ref="paginator" @fetch="(items) => (lista = items)" /> -->
                          <!--     <Pagination ref="paginator" @fetch="(items) => (lista = items)" /> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
